/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState, useEffect } from 'react';
import InViewComponent from '../../../shared/components/inView/inView';
import { ReactComponent as RightArrowSvg } from '../../../assets/images/arrow/icon_arrow_down.svg';


/**
 * OpportunitiesBox is used to render list of cards for opportunities
 */
const OpportunitiesBox = ({ opportunities_section_title, opportunities_section }) => {
    const [inView, setInView] = useState(false);
    return (
        <div className="opportunities-box" id="explore-opportunities">
            <div className="container">
                {
                    opportunities_section_title &&
                    <div className="heading-box">
                        <h2>{ opportunities_section_title }</h2>
                    </div>
                }

                <InViewComponent setInview={ setInView }>
                    <div className="opportunities-list">
                        {
                            opportunities_section && opportunities_section.map((obj, index) => {
                                return <CardComponent key={ index } index={ index + 2 } inView={ inView } cardContent={ obj } />;
                            })
                        }

                    </div>
                </InViewComponent>

            </div>
        </div>

    );
};


/**
 * CardComponent is functinal Component to render of opportunity card 
 * @param {*} props 
 */
const CardComponent = (props) => {
    const [className, setClassName] = useState('');
    const { content, cta_link, title } = props.cardContent;
    useEffect(() => {
        if (props.inView) {
            setTimeout(() => {
                if (props.inView) {
                    setClassName("is-animate");
                }
            }, 200 * props.index);
        } else {
            setTimeout(() => {
                if (!props.inView) {
                    setClassName("");
                }
            }, (1200 / props.index));
        }
    }, [props.inView, className]);
    return (
        <div className={ `card customAnim slide-top ${className}` }>
            <div className="inner-box">
                {
                    title &&
                    <h4>{ title }</h4>
                }
                {
                    content &&
                    <p>{ content }</p>
                }
                {
                    cta_link &&
                    <a href={ cta_link.url } className='link' target={ cta_link.target !== "" ? "_blank" : "_self" }>{ cta_link.title }</a>
                }
            </div>
            {
                cta_link &&
                <a href={ cta_link.url } className='linkIcon' target={ cta_link.target !== "" ? "_blank" : "_self" }><RightArrowSvg className='icon'></RightArrowSvg></a>

            }
        </div>
    );
};

export default OpportunitiesBox;